import { COMPANY_TYPE } from '@constants/app';
import { Avatar, Box, Typography, useTheme } from '@mui/material';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import {
  ConditionalTooltip,
  truncateText,
  useMasterData,
  useUserAccess,
} from '@ui-framework/index';

function UserToolTipText({ name, company }) {
  return (
    <Box>
      <Box>{name}</Box>
      <Box>{company}</Box>
    </Box>
  );
}

function HeaderUserAvatar() {
  const theme = useTheme();
  const userAccess = useUserAccess();
  const masterData = useMasterData();

  if (!userAccess) {
    return null;
  }

  const user = {
    firstName: userAccess?.firstName,
    lastName: userAccess?.lastName,
  };

  const loggedInUser = masterData?.frontendAppData?.loggedInUser;
  const subtext =
    userAccess.company.companyType === COMPANY_TYPE.SERVICE_PROVIDER
      ? loggedInUser?.name
      : userAccess?.company.companyNumber;
  const userFullName = `${user?.firstName} ${user?.lastName}`;

  return (
    <Box>
      <Box sx={{ display: { xs: 'flex', md: 'none' }, alignItems: 'center' }}>
        <Avatar
          {...(user?.avatar && { src: `${user?.avatar}` })}
          sx={{ bgcolor: theme.palette.primary.main }}
          alt={`${user?.firstName} ${user?.lastName}`}>
          {user?.firstName[0]}
          {user?.lastName[0]}
        </Avatar>
      </Box>
      <Grid2
        container
        spacing={1}
        alignItems="center"
        sx={{ display: { xs: 'none', md: 'flex' } }}>
        <Grid2>
          <Avatar
            {...(user?.avatar && { src: `${user?.avatar}` })}
            sx={{ bgcolor: theme.palette.primary.main, fontSize: '16px' }}
            alt={`${user?.firstName} ${user?.lastName}`}>
            {user?.firstName[0]}
            {user?.lastName[0]}
          </Avatar>
        </Grid2>
        <Grid2 textAlign="left">
          <ConditionalTooltip
            showCondition={userFullName.length > 10 || subtext.length > 10}
            title={<UserToolTipText name={userFullName} company={subtext} />}
            arrow>
            <Typography
              variant="body1"
              sx={{ color: theme.palette.tertiary.main }}>
              {truncateText(userFullName, 10)}
            </Typography>
            <Typography variant="body2" sx={{ color: theme.palette.mutedText }}>
              {truncateText(subtext, 12)}
            </Typography>
          </ConditionalTooltip>
        </Grid2>
      </Grid2>
    </Box>
  );
}

export default HeaderUserAvatar;
